import React, { useState, useContext } from "react";
import { AppContext } from "../../components/States/AppContext";
import { useNavigate } from "react-router-dom";

import {
  PopUpBox,
  PopUpButtonWrapper,
  PopUpStandByButtonCancel,
  PopUpStandByButtonConfirm,
  PopUpStandbyMessage,
  PopUpStandbyWrapFlex,
  PopUpStandbyWrapFlexContainer,
} from "../../components/PopUps/PopUp.elements";
import { StandbyBox } from "./StandbyScreen.elements";

import { BsExclamationTriangle } from "react-icons/bs";
import { FaExclamationTriangle } from "react-icons/fa";

import {
  DisclaimerBg,
  DisclaimerBox,
  DisclaimerButtonWrapper,
  DisclaimerLogo,
  DisclaimerLogoContainer,
  DisclaimerText,
  DisclaimerTitleBox,
} from "./Disclaimer.elements";

import logo from "../../img/misc/logo2.png";

const Disclaimer = () => {
  const { state, setState } = useContext(AppContext);

  const handleSubmit = () => {
    setState((prevState) => ({
      ...prevState,
      disclaimer: false,
      init: true,

      // telemetry: false,
      // piicConnected: false,
    }));
  };

  return (
    <>
      <DisclaimerBg>
        <DisclaimerBox>
          {/* <DisclaimerLogoContainer>

          <DisclaimerLogo src={logo}></DisclaimerLogo>
        </DisclaimerLogoContainer> */}
          <DisclaimerText>
            <DisclaimerTitleBox style={{ fontsize: "5em" }}>
              {/* <BsExclamationTriangle /> */}
              <div></div>
              <FaExclamationTriangle
                style={{ color: " #1f729f", fontSize: "1.5rem" }}
              ></FaExclamationTriangle>

              <div>Disclaimer</div>
            </DisclaimerTitleBox>
            {/* <div style={{fontSize:"1rem"}}>Disclaimer:</div> */}
            {/* Disclaimer: */}
            {/* <br></br> */}
            {/* <br></br> */}
            <br></br>
            Your use of this simulation is for demonstration purposes only.
            <br></br>
            <br></br>
            The simulated User Interface may differ from the 5500 User Interface
            in your hospital.
            {/* Enter Standby for selected <br></br> time?{" "} */}
          </DisclaimerText>

          <div>
            <DisclaimerButtonWrapper>
              <PopUpStandByButtonConfirm onClick={handleSubmit}>
                Accept
              </PopUpStandByButtonConfirm>
            </DisclaimerButtonWrapper>
          </div>
        </DisclaimerBox>
      </DisclaimerBg>
    </>
  );
};

export default Disclaimer;
